import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import styled from '@emotion/styled';

import useUserContext from '../../hooks/use-user-context';
import { createOptionMap } from '../../utilities/misc';
import { rem } from '../../utilities/style';
import { colors } from '../../theme/colors';
import { containerStyles } from '../../styles/layout';

import TextRenderer from '../TextRenderer';

const Container = styled.footer`
  font-size: ${rem(14)};
  background:${colors.white};
  color: ${colors.blue['800']};
`;

const ContentWrapper = styled.div`
  ${containerStyles.regular}
`;

const Notice = styled.div`
  padding: ${rem(20)} 0px;
  color: ${colors.gray['600']};
  text-align: center;
`;

const year = new Date().getFullYear();

const FooterSimple = () => {
  const data = useStaticQuery(graphql`
    query FooterSimple {
      allContentfulOptionSet(filter: {name: {eq: "footer"}}) {
        nodes {
          ...OptionSetFragment
        }
      }
    }
  `);
  const { language } = useUserContext();
  const options = createOptionMap(data.allContentfulOptionSet.nodes, language);
  const copyrightNotice = options['footer.copyright_notice']
    ?.replace('{{year}}', year);

  return (
    <Container>
      <ContentWrapper>
        <Notice>
          <TextRenderer text={copyrightNotice} />
        </Notice>
      </ContentWrapper>
    </Container>
  );
};

export default FooterSimple;
